import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
export default class IgnoreDiscussionModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
  }
  className() {
    return 'IgnoreDiscussionModal Modal--small';
  }
  title() {
    return app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "Form-group"
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.confirmation_text')), m("p", {
      className: "Form-group helpText"
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.manage_info'), ' ', m("a", {
      href: app.route('bizkaitarra.ignoredDiscussions'),
      onclick: e => {
        this.hide();
        m.route.set(app.route('bizkaitarra.ignoredDiscussions'));
      }
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.link_text')), "."), m("div", {
      className: "Form-group",
      style: "display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px;"
    }, m(Button, {
      className: "Button",
      type: "button",
      onclick: () => this.hide()
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.cancel_button')), m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.submit_button'))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.discussion.save({
      ignored: true
    }).then(() => {
      this.hide();
      if (app.discussions && app.discussions.pages) {
        app.discussions.pages.forEach(page => {
          if (page.items) {
            page.items = page.items.filter(item => item.id() !== this.discussion.id());
          }
        });
      }
      if (this.attrs.onignored) {
        this.attrs.onignored();
      }
      if (app.current && app.current.matches && app.current.matches(DiscussionPage)) {
        app.history.back();
      } else {
        m.redraw();
      }
      let alertId;
      alertId = app.alerts.show({
        type: 'success'
      }, m("span", null, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.success_message'), ' ', m("a", {
        href: app.route('bizkaitarra.ignoredDiscussions'),
        onclick: e => {
          e.preventDefault();
          if (alertId !== undefined && app.alerts.dismiss) {
            app.alerts.dismiss(alertId);
          }
          if (app.alerts && app.alerts.clear) {
            app.alerts.clear();
          }
          m.route.set(app.route('bizkaitarra.ignoredDiscussions'));
        },
        style: "font-size: 0.9em; opacity: 0.9; text-decoration: underline; color: inherit; white-space: nowrap;"
      }, "(", app.translator.trans('bizkaitarra-ignore-users.forum.ignore_discussion_modal.manage_link_text'), ")")));
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('bizkaitarra-ignore-users', 'forum/components/IgnoreDiscussionModal', IgnoreDiscussionModal);